import axios, {CreateAxiosDefaults, isAxiosError} from 'axios';
import Cookies from 'js-cookie';

import {ExternalUrl} from '~/utils/routes';

const config: CreateAxiosDefaults = {
  baseURL: ENV_HOT_API,
  timeout: 0,
};

if (process.env.NODE_ENV === 'development') {
  config.headers = {
    Authorization: `Bearer ${Cookies.get('auth_token')}`,
  };
}

if (process.env.NODE_ENV === 'production') {
  config.withCredentials = true;
}

const instance = axios.create(config);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isAxiosError(error) && error.response) {
      const isNotificationsError = error.request.responseURL.includes(
        '/frontend/api/v1/notifications'
      );

      if (!isNotificationsError && error.response.status === 401) {
        window.location.href = ExternalUrl.Logout;
      }

      if (error.response.status === 403) {
        window.location.href = ExternalUrl.Dashboard;
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
